import React from "react";
import { RaisedButton } from "material-ui";
import BallotingRecord from "./balloting-record.jsx";
import connectToStores from "alt-utils/lib/connectToStores";
import EventStore from "../../stores/EventStore";
import EventActions from "../../actions/EventActions";
import TicketStore from "../../stores/TicketStore";
import TicketActions from "../../actions/TicketActions";

@connectToStores
class ViewCartButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };
  }

  static getStores() {
    return [EventStore, TicketStore];
  }

  static getPropsFromStores() {
    return {
      getEventById: EventStore.getEventById,
      getTicketsByEventId: TicketStore.getTicketsByEventId,
    };
  }

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
    appSettings: React.PropTypes.object,
    isLarge: React.PropTypes.bool
  };

  componentWillMount() {
    EventActions.fetchAll.defer();
    TicketActions.fetchAll.defer();
  }

  render() {
    const { 
      enable_cart
    } = this.context.appSettings;

    let { style, label, showCart } = this.props;

    let button = (
      <RaisedButton
        className="eventive__view-cart-button__button"
        label={label || "View Cart"}
        labelPosition="before"
        primary={true}
        onClick={() => { showCart(); }}
      >
      </RaisedButton>
    );

    // EE informational error message
    if (!enable_cart) {
      console.log("Eventive Everywhere View Cart Button: Render failed - cart is not enabled for this event bucket");
    }

    return (
      <div
        className="eventive__view-cart-button__container"
      >
        {enable_cart ? button : null}
      </div>
    );
  }
}

export default ViewCartButton;



// WEBPACK FOOTER //
// ./src/app/components/partials/view-cart-button.jsx